import React, { useCallback, useContext, useEffect, useLayoutEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Id from "../../components/Formatters/Id";
import IE from "../../components/Formatters/IE";
import DropDownSpfPermission from "../../components/UI/Button/DropDownSpfPermission";
import { AuthContext } from "../../context/AuthContext";
import funcionalidades from "../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import ConsultaProcedimentoFiscal from "./ConsultaProcedimentoFiscal";
import HomologaProcedimentoFiscal from "./HomologaProcedimentoFiscal";
import TextSpinner from "../../components/UI/Spinner/TextSpinner";
import { formatarData } from "../../components/Formatters/DateTime";
import constants from "../Constants";

const columns = [
  {
    name: "Nº SPF",
    cell: (row) => row.numeroAberturaProcesso,
    maxWidth: "10%",
  },
  {
    name: "Data de Inclusão",
    cell: (row) => formatarData(row.dataInclusao),
    maxWidth: "10%",
    center: true,
  },
  {
    name: "Inscrição Estadual",
    cell: (row) => (row.numeroIe === "" ? " " : <IE value={row.numeroIe} />),
    maxWidth: "10%",
    center: true,
  },
  {
    name: "CNPJ/CPF",
    cell: (row) => <Id value={row.numeroCnpjCpf} />,
    maxWidth: "15%",
    center: true,
  },

  {
    name: "Razão Social",
    cell: (row) => row.nomeContribuinte,
    maxWidth: "25%",
  },
  {
    name: "Setor",
    cell: (row) => row.nomeSetor,
    maxWidth: "10%",
  },
  {
    name: "Motivo de Revisão",
    cell: (row) => row.txRevisao,
    maxWidth: "20%",
  },
];

const PendenciaProcedimentoFiscal = ({ history, match }) => {
  const { isAllowed } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParameters] = useState({});
  const [key, setKey] = useState(constants.spf.todos);
  const [situacao, setSituacao] = useState();

  const { location } = history;
  const { state } = location;

  useLayoutEffect(() => {
    if (sessionStorage.getItem("key")) {
      setKey(sessionStorage.getItem("key"));
    } else if (isAllowed(funcionalidades.spf.homologar)) {
      setKey(constants.spf.homologar);
    } else if (isAllowed(funcionalidades.spf.revisar)) {
      setKey(constants.spf.revisao);
    }

    if (state !== undefined) {
      const { todos, status } = state;
      setSituacao(status);
      setKey(todos);
    }
  }, [isAllowed, state, situacao]);

  const { request: requestConsulta, data: dataConsulta, errors: errorConsulta, isLoading } = useApiClient();

  useEffect(() => {
    if (key === constants.spf.revisao) {
      requestConsulta(apiRoutes.fiscalizacao.procedimentoFiscal.consultaSpfRevisao, {
        ...searchParameters,
        pageSize,
        pageNumber,
      });
    }
  }, [requestConsulta, searchParameters, pageSize, pageNumber, key]);

  useEffect(() => {
    if (dataConsulta && dataConsulta.result) {
      if (dataConsulta.result.length && !dataConsulta.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados.`);
        return;
      }

      setRows(dataConsulta.result || []);
      setTotalRows(dataConsulta.result.length ? dataConsulta.result[0].totalRows : 0);
    }

    if (errorConsulta) {
      toast.error(errorConsulta.message);
    }
  }, [dataConsulta, errorConsulta]);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  return (
    <>
      {/* Cabeçalho da Página */}
      <h1 className="h3 mb-4 text-gray-800">Solicitação de Procedimento Fiscal</h1>
      <div className="row">
        <div className="col-lg-12">
          {/* Conteúdo personalizado (card) */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="12" className="form-inline justify-content-end">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">Operações com SPF</h6>
                  <DropDownSpfPermission permission={funcionalidades.spf.inserir} history={history} match={match} />
                </Col>
              </Row>
            </div>
            <div className="card-body">
              {(isAllowed(funcionalidades.spf.homologar) ||
                isAllowed(funcionalidades.spf.revisar) ||
                isAllowed(funcionalidades.spf.consultar)) && (
                <Tabs id="tabSpfPendencias" activeKey={key} onSelect={(k) => setKey(k)}>
                  {isAllowed(funcionalidades.spf.homologar) && (
                    <Tab eventKey={constants.spf.homologar} title="Para Homologar">
                      {key === constants.spf.homologar ? <HomologaProcedimentoFiscal /> : null}
                    </Tab>
                  )}

                  {isAllowed(funcionalidades.spf.alterar) && (
                    <Tab eventKey={constants.spf.revisao} title="Para Revisar">
                      <DataTable
                        noHeader
                        keyField="numero"
                        columns={columns}
                        data={rows}
                        progressPending={isLoading}
                        noDataComponent="Nenhum registro para exibir"
                        progressComponent={<TextSpinner />}
                        sortServer
                        pagination
                        onRowClicked={(item) => {
                          history.push({
                            pathname: `${match.url}/form`,
                            search: "",
                            state: {
                              itemKey: item.numeroAberturaProcesso,
                              tipoOrigem: item.tipoOrigem,
                              documento: item.numeroIe,
                              sequencialOrigem: item.sequencialOrigem,
                            },
                          });
                        }}
                        pointerOnHover
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationComponentOptions={constants.paginationComponentOptions}
                        paginationPerPage={pageSize}
                        paginationTotalRows={totalRows}
                      />
                    </Tab>
                  )}

                  {isAllowed(funcionalidades.spf.consultar) && (
                    <Tab eventKey={constants.spf.todos} title="Todas">
                      {key === constants.spf.todos ? (
                        <ConsultaProcedimentoFiscal history={history} match={match} />
                      ) : null}
                    </Tab>
                  )}
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendenciaProcedimentoFiscal;
